// src/components/Turmas/TabelaTurma.js
import React, { useState } from "react";
import { FaExchangeAlt, FaTrash } from "react-icons/fa";
import Modal from "react-modal";
import MoverAlunoModal from "./MoverAlunoModal";
import styles from "./Turmas.module.css";

const MAX_ALUNOS = 50;

const TabelaTurma = ({ turmasFiltradas, setAtivos, setTurmas, singleView = false }) => {
  const [alunoSelecionado, setAlunoSelecionado] = useState(null);

  const removerAluno = (alunoId, turma) => {
    if (!window.confirm("Tem certeza que deseja remover este aluno da turma?")) return;
    setAtivos(prev => prev.map(a => a.id === alunoId ? { ...a, turma: null } : a));
    setTurmas(prev => ({ ...prev, [turma]: prev[turma].filter(a => a.id !== alunoId) }));
  };

  const moverAluno = (aluno, novaTurma) => {
    setAtivos(prev => prev.map(a => a.id === aluno.id ? { ...a, turma: novaTurma } : a));
    setTurmas(prev => {
      const origem = aluno.turma || "Sem Turma";
      const listaOrigem = prev[origem] ? prev[origem].filter(a => a.id !== aluno.id) : [];
      const listaDestino = prev[novaTurma] ? [...prev[novaTurma]] : [];
      listaDestino.push({ ...aluno, turma: novaTurma, numero: listaDestino.length + 1 });
      return { ...prev, [origem]: listaOrigem, [novaTurma]: listaDestino };
    });
    setAlunoSelecionado(null);
  };

  const turmaKeys = Object.keys(turmasFiltradas);

  if (!turmaKeys.length) {
    return <p className={styles.centerMsg}>Nenhum aluno encontrado.</p>;
  }

  return (
    <>
      {turmaKeys.map((turmaKey) => {
        const alunos = turmasFiltradas[turmaKey];
        const vagasDisponiveis = MAX_ALUNOS - alunos.length;

        return (
          <div key={turmaKey} className={styles.turmaCard} style={{ maxHeight: "400px", overflowY: "auto" }}>
            {/* Se singleView=true e só há uma turma, não repetimos o título "Turma X" aqui */}
            {!singleView && <h4>{`Turma ${turmaKey}`}</h4>}
            <p>Vagas disponíveis: {vagasDisponiveis}</p>

            <table>
              <thead>
                <tr>
                  <th>Nº</th>
                  <th>Nome completo</th>
                  <th>Gênero</th>
                  <th>Código</th>
                  <th>Classe</th>
                  <th>Idade</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {alunos.map(aluno => (
                  <tr key={aluno.id}>
                    <td>{aluno.numero}</td>
                    <td>{aluno.nome_completo || aluno.nome}</td>
                    <td>{aluno.genero || "-"}</td>
                    <td>{aluno.codigo || "—"}</td>
                    <td>{aluno.classe}</td>
                    <td>{aluno.idade}</td>
                    <td className={styles.actionBtns}>
                      <button title="Mover de turma" onClick={() => setAlunoSelecionado(aluno)}>
                        <FaExchangeAlt />
                      </button>
                      <button title="Remover aluno" onClick={() => removerAluno(aluno.id, aluno.turma)}>
                        <FaTrash />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>

            {/* Modal mover aluno */}
            <Modal
              isOpen={!!alunoSelecionado}
              onRequestClose={() => setAlunoSelecionado(null)}
              className={styles.modal}
              overlayClassName={styles.modalOverlay}
            >
              {alunoSelecionado && (
                <MoverAlunoModal
                  aluno={alunoSelecionado}
                  turmasExistentes={Object.keys(turmasFiltradas)}
                  onMover={(al, nova) => moverAluno(al, nova)}
                  onFechar={() => setAlunoSelecionado(null)}
                />
              )}
            </Modal>
          </div>
        );
      })}
    </>
  );
};

export default TabelaTurma;
